module.exports = __webpack_public_path__ + "static/instagram-272a194696f6a8d8de6063f177308203.png";